export const MIGRATION_CONFIG = {
  MAX_RETRIES: 3,
  DEBOUNCE_TIME: 300,
  PAGE_SIZE_OPTIONS: [5, 10, 25, 50],
  DEFAULT_PAGE_SIZE: 10
};

export const FILTER_DEFAULT_VALUE = 'all';
export const FILTER_EXCLUSIONS = ['all', null, ''];

export const UNIT_HIERARCHY_UNASSIGNED = [
  'Sin asignar',
  'Desconocido',
  'Iglesia Regional'
];

export const TABLE_COLUMNS = {
  USER_INFO: 'userInfo',
  ACCESOS: 'accesos',
  UNIDAD: 'unidad',
  STATUS: 'status',
  ACTIONS: 'actions'
};

export const DISPLAYED_COLUMNS = [
  TABLE_COLUMNS.USER_INFO,
  TABLE_COLUMNS.ACCESOS,
  TABLE_COLUMNS.UNIDAD,
  TABLE_COLUMNS.STATUS,
  TABLE_COLUMNS.ACTIONS
];
